export var GroupRestrictedSpotType;
(function (GroupRestrictedSpotType) {
    GroupRestrictedSpotType[GroupRestrictedSpotType["Other"] = 0] = "Other";
    GroupRestrictedSpotType[GroupRestrictedSpotType["ContactsSupport"] = 1] = "ContactsSupport";
    GroupRestrictedSpotType[GroupRestrictedSpotType["GetStarted"] = 2] = "GetStarted";
})(GroupRestrictedSpotType || (GroupRestrictedSpotType = {}));
;
